export const STORAGE_KEY_LOCALE_LANG = 'smd-i18n-lang';
export const STORAGE_SURVEY_KEY = 'smd-survey-data';
export const STORAGE_CART_KEY = 'smd-independent-reserve-cart';

export const DEFAULT_LOCALE_LANG = import.meta.env?.REACT_APP_SAMAD_LOCALE_LANG ?? 'fa';

// export const PAYMENT_RESULT_URL = 'http://localhost:3000';
export const PAYMENT_RESULT_URL = 'https://test.samad.app';

export enum Locales {
  Persian = 'fa',
  English = 'en',
  Arabic = 'ar'
}

export enum GatewayConsumer {
  CreditCharge = 'CreditCharge'
}

export const NON_MANAGEMENT_ROLES = [
  'ROLE_STUDENT',
  'ROLE_NURTURE_USER',
  'ROLE_REFAH_SETTLEMENT_STUDENT',
  'ROLE_REFAH_LOAN_STUDENT',
  'ROLE_ESKAN_ALGORITM_STUDENT',
  'ROLE_RS_MOBILE_APP',
  'ROLE_RS_NURTURE_VOTE',
  'ROLE_RS_VOTE_REASONS',
  'ROLE_RS_USERS_ME',
  'ROLE_RS_USERS_ME_CHANGE_PASSWORD'
];

export const BASKET_EXPIRATION_TIME = 600000;
